import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const ModalBodyInnerContainer = styled(Box)`
  max-height: 60dvh;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-right: 1rem;
`;
